import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from 'material-ui-icons/Info';
import {
  republicOfferRequestInformationMutation,
  investorOffersQuery,
  offerQuery,
} from '../../../apollo';
import RequestInformationAction from './RequestInformationAction';
import { DASHBOARD_OFFER_LIMIT as limit } from '../../../config';

const republicOfferRequestInformation = ({
  offerId,
  linkForm,
  republicRequestform,
}) => (
  <RequestInformationAction
    offerId={offerId}
    mutation={republicOfferRequestInformationMutation}
    refetchQueries={[
      {
        query: investorOffersQuery,
        variables: {
          query: {
            limit,
            skip: 0,
            sort: 'order',
            order: 'ASC',
            filter: {
              $or: [
                {
                  favorited: true,
                },
                {
                  requestedInformation: true,
                },
                {
                  readyToInvest: true,
                },
              ],
            },
          },
        },
      },
      {
        query: offerQuery,
        variables: {
          _id: offerId,
        },
      },
    ]}
    Icon={InfoIcon}
    title={'Request Information'}
    dialogBody={`Thank you for visiting. Based on the
    investment preferences you've provided this
    opportunity does not appear to be a suitable
    investment for you. If you would like more
    information, please submit a request to the
    banker.`}
    enableMessage
    republicRequestform={republicRequestform}
  />
);

republicOfferRequestInformation.propTypes = {
  offerId: PropTypes.string.isRequired,
  linkForm: PropTypes.bool,
  republicRequestform: PropTypes.bool,
};

export default republicOfferRequestInformation;



// WEBPACK FOOTER //
// ./src/components/RepublicOffer/RepublicRequestInformationButton/index.js